import type { Directive } from 'vue'
export const vReplace: Directive<
  HTMLInputElement,
  Array<{ value: string; replaceValue: string }>
> = {
  beforeMount(quasarEl, binding) {
    const el = quasarEl.querySelector('input')
    if (!el) {
      console.warn('input not found')
      return
    }
    const applyFilters = (text: string): string => {
      let filteredText = text
      binding.value.forEach((filter) => {
        const regex = new RegExp(filter.value, 'gi')
        filteredText = filteredText.replace(regex, filter.replaceValue)
      })
      return filteredText
    }

    const handleInput = (event: Event) => {
      const target = event.target as HTMLInputElement
      const originalValue = target.value
      const originalPosition = target.selectionStart ?? 0
      const filteredValue = applyFilters(originalValue)

      if (originalValue !== filteredValue) {
        target.value = filteredValue // Set the filtered value directly
        nextTick(() => {
          target.setSelectionRange(originalPosition, originalPosition)
        })
      }
    }

    const handlePaste = (event: ClipboardEvent) => {
      event.preventDefault()
      const pastedText = event.clipboardData?.getData('text') ?? ''
      const cleanedText = applyFilters(pastedText)
      document.execCommand('insertText', false, cleanedText)
    }

    el.addEventListener('input', handleInput)
    el.addEventListener('paste', handlePaste)
  },
  unmounted(quasarEl, binding) {
    const el = quasarEl.querySelector('input')
    if (!el) {
      console.warn('input not found')
      return
    }
    el.removeEventListener('input', (binding.instance as any)?.handleInput)
    el.removeEventListener('paste', (binding.instance as any)?.handlePaste)
  },
}
